'use strict';

var omit = require('lodash.omit');

module.exports = function (params) {
  if (params.classification || params.subclassification) {
    return {
      classification: omit(params, ['classification', 'subclassification'])
    };
  }

  return {};
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-refine-job-search/dist/refinements/clear/classification.js
 ** module id = 501
 ** module chunks = 0
 **/